import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function TelefonBagimliligiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['telefon-bagimliligi-testi']} />;
}
